(function(){
  'use strict';
  angular.module("irricrops")
    .config(['$stateProvider', '$urlRouterProvider', 'CONSTANTES',function($stateProvider, $urlRouterProvider, CONSTANTES) {
      $urlRouterProvider.otherwise("/");
      $stateProvider

        .state('login', {
          url   : "/login?url",
          views : {
            'absoluteView':{
              templateUrl  : "components/login/login.view.html",
              controller   : "loginCtrl",
              controllerAs : "lo",
            }
          }
        })

        .state('initial', {
          url:"/"
        })

        .state('404', {
          url         : "/404",
          title       : "No Encontrado",
          templateUrl : "shared/404.view.html",
        })

        .state('403', {
          url         : "/403",
          title       : "No Tiene Permisos",
          templateUrl : "shared/403.view.html",
        })


        //----------------------------------------------------------
        //------ VINEDO --------------------------------------------
        //----------------------------------------------------------

        .state('vinedo', {
          redirectTo    : CONSTANTES.INITIAL_STATE,
          title         : 'Viñedo',
          url           : "/campo/{id:int}",
          templateUrl   : "components/vinedo/vina.view.html",
          controller    : "vinedoCtrl",
          controllerAs  : "vin",
          resolve:{
            vinedo: ['VinedoFac', '$stateParams', 'global', 'Config', 'newCacheManager', 'menu',
            function (VinedoFac, $stateParams, global, Config, NCM, menu) {

              var prom = menu.getMe().then( () => VinedoFac.getData($stateParams.id, null).$promise );

              prom.then(function(res){
                global.title = res.data.nombre;
                global.titleData = null;
                Config.vinedo = res.data.configuracion;
                global.logo = res.data.logo;
                angular.forEach(Config.vinedo, function(item, index){
                  if (item == '1' || item === 1) {
                    Config.vinedo[index] = true;
                  }
                  if (item == '0' || item === 0) {
                    Config.vinedo[index] = false;
                  }
                });
                return res;
              });

              return prom;
            }],

          }
        })


        /*
        .state('vinedo.inicio', {
          url          : "/inicio",
        debugger;
          templateUrl  : "components/vinedo/inicio/vina.inicio.view.html",
          load         : true,
          title        : 'inicio',
          controller   : 'vinedoInicioCtrl',
          controllerAs : 'ini'
        })
        */

        .state('vinedo.resumen', {
          url            : "/resumen",
          templateUrl    : "components/vinedo/resumen/vina.resumen.view.html",
          title          : 'resumen',
          controller     : 'vinedoResumenCtrl',
          controllerAs   : 'vr',
          resolve: {
            resumen: ["VinedoRes", "$stateParams", function(VinedoRes, $stateParams){
              return VinedoRes.getResumen({
                vinedo_id : $stateParams.id
              }).$promise;
            }]
          }
        })





        .state('vinedo.sectores', {
          url            : "/sectores?mes&inicio&termino&estado&temporada&comparacion",
          reloadOnSearch : false,
          templateUrl    : "components/vinedo/sectores/vina.sectores.view.html",
          load           : true,
          title          : 'Sectores',
          controller     : 'vinedoSectoresCtrl',
          controllerAs   : 'vcs',
        })


        .state('vinedo.analisis', {
          url            : "/Historico?mes&inicio&termino&estado&temporada&comparacion",
          reloadOnSearch : false,
          templateUrl    : "components/vinedo/analisis/vina.analisis.view.html",
          load           : true,
          title          : 'Analisis',
          controller     : 'vinedoAnalisisCtrl',
          controllerAs   : 'vcs' //vestigial, deberia ser van
        })

          .state('vinedo.estacion', {
            url            : "/estacion",
            //reloadOnSearch : false,
            templateUrl    : "components/vinedo/estacion/vina.estacion.view.html",
            load           : true,
            title          : 'Estación',
            controller     : 'vinedoEstacionCtrl',
            controllerAs   : 'es'
          })

          .state('vinedo.seguimiento', {
            url            : "/analisis",
            //reloadOnSearch : false,
            templateUrl    : "components/vinedo/seguimiento/vina.seguimiento.view.html",
            load           : true,
            title          : 'Seguimiento',
            controller     : 'vinedoSeguimientoCtrl',
            controllerAs   : 'seg'
          })


      /*

          .state('vinedo.seguimientoIrriview', {
            url            : "/analisisIrriview",
            //reloadOnSearch : false,
            templateUrl    : "components/vinedo/seguimientoIrriview/vina.seguimientoIrriview.view.html",
            load           : true,
            title          : 'Seguimiento Irriview',
            controller     : 'vinedoSeguimientoIrriviewCtrl',
            controllerAs   : 'seg'
          })



*/




          /*
           .state('vinedo.comparacion', {
            url            : "/comparacion?mes&inicio&termino&estado&temporada",
            reloadOnSearch : false,
            templateUrl    : "components/vinedo/comparacion/vina.comparacion.view.html",
            load           : true,
            title          : 'Comparación Viñedo',
            controller     : 'vinedoComparacionCtrl',
            controllerAs   : 'vcc',
          })



          .state('vinedo.timeline', {
            url: "/timeline",
            views:{
              "":{
                controller   : 'timelineCtrl',
                controllerAs : 'vtl',
                templateUrl  : "components/vinedo/timeline/timeline.view.html",
                resolve      : {

                  estados: ["$http", "$stateParams", "urls","$q","temporadaFac",
                  function($http, $stateParams, urls, $q, temporadaFac){
                    return $http.get(urls.BASE+"/vinedo/estados-fenologicos?vinedo_id="+$stateParams.id);
                  }],

                  volumenes: ["$http", "$stateParams", "urls","$q","temporadaFac",
                  function($http, $stateParams, urls, $q, temporadaFac){
                    return $http.get(urls.BASE+"/vinedo/volumenes?vinedo_id="+$stateParams.id);
                  }],

                  estadisticas: ['VinedoFac', '$stateParams',
                  function(VinedoFac, $stateParams){
                    return VinedoFac.getSensores({vinedo_id: $stateParams.id, fecha: new Date()},
                    function(data){
                      //success
                    });
                  }],
                }
              },
              'absoluteView@':{
                templateUrl  : "shared/timeTable/popover/programacion.tmpl.html",
                  controller : 'popoverProgramacionCtrl',
                controllerAs : 'pp',
              }
            }
          })
          */

        .state('vinedo.newtimeline', {
          url: "/planilla",
          views:{
            "":{
              controller   : 'ntimelineCtrl',
              controllerAs : 'vtl',
              templateUrl  : "components/vinedo/newtimeline/timeline.view.html",
              resolve      : {

                estados: ["$http", "$stateParams", "urls","$q","temporadaFac",
                function($http, $stateParams, urls, $q, temporadaFac){
                  return $http.get(urls.BASE+"/vinedo/estados-fenologicos?vinedo_id="+$stateParams.id);
                }],

                volumenes: ["$http", "$stateParams", "urls","$q","temporadaFac",
                function($http, $stateParams, urls, $q, temporadaFac){
                  return $http.get(urls.BASE+"/vinedo/volumenes?vinedo_id="+$stateParams.id);
                }],
                /*sectoresSensor: ["VinedoRes","$stateParams", "vinedo" ,
                  function(VinedoRes, $stateParams, vinedo){
                    return VinedoRes.getSensores({vinedo_id: $stateParams.id, fecha: new Date(), mapa:true, con_sensores: false},
                      function(data){
                        // success
                      }).$promise;
                }]*/
              }
            },
            /*'absoluteView@':{
              templateUrl  : "shared/timeTable/popover/programacion.tmpl.html",
                controller : 'popoverProgramacionCtrl',
              controllerAs : 'pp',
            }*/
          }
        })




      /*
        .state('vinedo.temporadas', {
          url: "/temporadas",
          views:{
            "":{
              controller  : 'vinedoTempCtrl',
              controllerAs: 'vt',
              templateUrl : "components/vinedo/temporadas/vina.temp.view.html",
            }
          }
        })
        */


        .state('vinedo.prodres', {
          url: "/prodres",
          views:{
            "":{
              controller   : 'vinedoProdResCtrl',
              controllerAs : 'm',
              templateUrl  : "components/vinedo/prod-resumen/vina.prodres.view.html",
            }
          }
        })



      /*
        .state('vinedo.tracking', {
          url: "/tracking",
          views:{
            "":{
              controller  : 'vinedoTrackCtrl',
              controllerAs: 't',
              templateUrl : "components/vinedo/track/vina.track.view.html",
            }
          }
        })
        */



        .state('vinedo.productividad', {
          url: "/productividad?:cid",
          reloadOnSearch : false,
          views:{
            "":{
              controller   : 'productividadCtrl',
              controllerAs : 'm',
              templateUrl  : "components/vinedo/productividad/productividad.view.html",
              resolve      : {
                vinedoData: ["productividadFac","$stateParams",
                function(pf, $stateParams){
                  return pf.getVinedo($stateParams.id);
                }]
              }
            }
          }
        })



        .state('vinedo.catastro', {
          url: "/catastro",
          views:{
            "":{
              controller   : 'catastroCtrl',
              controllerAs : 'c',
              templateUrl  : "components/vinedo/catastro/catastro.view.html",
              resolve      : {
                resumen: ["VinedoRes", "$stateParams", function(VinedoRes, $stateParams){
                  return VinedoRes.getResumen({
                    vinedo_id : $stateParams.id
                  }).$promise;
                }]
              }
            }
          }
        })

      /*
        .state('vinedo.huella', {
          url: "/cuarteles",
          views:{
            "":{
              controller   : 'huellaCtrl',
              controllerAs : 'h',
              templateUrl  : "components/vinedo/huella/huella.view.html",
            }
          }
        })
*/




        .state('vinedo.mapa', {
          url          : "/mapa",
          controller   : 'vinedoMapaCtrl',
          controllerAs : 'vmp',
          configVinedo : 'conMapa',
          templateUrl  : "components/vinedo/mapa/vinedo.mapa.view.html",
          resolve      : {
            gma:["uiGmapGoogleMapApi",function( uiGmapGoogleMapApi ){
                  return uiGmapGoogleMapApi ;
                }],

            cuartelesData: ["VinedoRes","$stateParams", "vinedo" ,function(VinedoRes, $stateParams, vinedo){
                  return VinedoRes.getCuartelesData({vinedo_id: $stateParams.id, fecha: new Date()},
                  function(data){
                    // success
                  }).$promise;
                }],
            sectoresData: ["VinedoRes","$stateParams", "vinedo" ,function(VinedoRes, $stateParams, vinedo){
                  return VinedoRes.getSectoresData({vinedo_id: $stateParams.id, fecha: new Date()},
                  function(data){
                    // success
                  }).$promise;
                }],
						scholanderData: ["VinedoRes","$stateParams", "vinedo" ,function(VinedoRes, $stateParams, vinedo){
							return VinedoRes.getScholanderData({vinedo_id: $stateParams.id, fecha: new Date()},
									function(data){
										// success
									}).$promise;
						}],
            sensoresData: ["VinedoRes","$stateParams", "vinedo" ,function(VinedoRes, $stateParams, vinedo){
                  return VinedoRes.getSensores({vinedo_id: $stateParams.id, fecha: new Date(), mapa:true},
                  function(data){
                    // success
                  }).$promise;
                }],
            mapaVinedo: ["VinedoFac","$stateParams", "vinedo" ,function(VinedoFac, $stateParams, vinedo){
                  return VinedoFac.getMap({vinedo_id: $stateParams.id, fecha: new Date()},
                  function(data){
                    // success
                  });
                }]
          }
        })

/*      DEPRECATED

        .state('vinedo.et', {
          url          : "/et",
          controller   : "vinedoEtCtrl",
          controllerAs : "vet",
          templateUrl  : "components/vinedo/et/vina.et.view.html",
          __resolve      : {

            //usando vinedoRes y no VinedoFac para no usar cache
            evapotranspiracion: ['VinedoRes', '$stateParams',
              function(VinedoRes, $stateParams){
                return VinedoRes.getEt({vinedo_id: $stateParams.id, fecha: new Date()},
                    function(data){
                      //success
                    }).$promise;
              }],

            precipitacion: ['VinedoRes', '$stateParams',
              function(VinedoRes, $stateParams){
                return VinedoRes.getPrecip({vinedo_id: $stateParams.id, fecha: new Date()},
                    function(data){
                      //success
                    }).$promise;
              }],

            temperatura: ['VinedoRes', '$stateParams',
              function(VinedoRes, $stateParams){
                return VinedoRes.getTemp({vinedo_id: $stateParams.id, fecha: new Date()},
                    function(data){
                      //success
                    }).$promise;
              }]

          }
        })
*/
       .state('vinedo.sensores', {
          url          : "/sensores",
          controller   : "vinedoSensoresCtrl",
          controllerAs : "vsen",
          templateUrl  : "components/vinedo/sensores/vina.sensores.view.html",

          resolve:{
            estadisticas: ['VinedoFac', '$stateParams',
            function(VinedoFac, $stateParams){
              return VinedoFac.getSensores({vinedo_id: $stateParams.id, fecha: new Date()},
                  function(data){
                    //success
                  });
            }],
          }
        })

        .state('vinedo.agroalcubo', {
          url            : "/agroalcubo",
          templateUrl    : "components/vinedo/mai/mai.view.html",
          title          : 'Agroalcubo',
          controller     : 'vinedoMaiCtrl',
          controllerAs   : 'mai',
        })

        .state('vinedo.sp', {
          url            : "/sp",
          templateUrl    : "components/vinedo/sp/sp.view.html",
          title          : 'SP',
          controller     : 'vinedoSPCtrl',
          controllerAs   : 'sp',
        })

      /*

        .state('vinedo.calidades', {
          url         : "/calidades?mes&inicio&termino&estado&temporada",
          templateUrl : "components/vinedo/calidad/vina.cal.view.html",
          load        : true,
          reloadOnSearch :  false,
          title       : 'Calidades',
          resolve     : {
            calidades: ['VinedoFac', '$stateParams',
            function (VinedoFac, $stateParams) {
              return VinedoFac.getCalidades({vinedo_id:$stateParams.id},function(){
                //success
              });
            }],
            resumen : ['estadisticaFac', '$stateParams', function(estadisticaFac, $stateParams) {
              return estadisticaFac.getResumenCalidad({vinedo_id: $stateParams.id}).$promise;
            }]
          },
        controller: 'vinedoCalCtrl',
        controllerAs: 'vcal'
        })



        .state('vinedo.variedades', {
          url         : "/variedades?mes&inicio&termino&estado&temporada",
          reloadOnSearch :  false,
          load        : true,
          title       : 'Variedades',
          templateUrl : "components/vinedo/variedad/vina.var.view.html",
          resolve     : {
            variedades: ['VinedoFac', '$stateParams',
            function (VinedoFac, $stateParams) {
              return VinedoFac.getVariedades({vinedo_id:$stateParams.id}, function(){
                //success
              });
            }],
            resumen : ['estadisticaFac', '$stateParams', function(estadisticaFac, $stateParams) {
              return estadisticaFac.getResumenVariedad({vinedo_id: $stateParams.id}).$promise;
            }]
          },
        controller: 'vinedoVarCtrl',
        controllerAs: 'vvar'
        })



        .state('vinedo.producciones', {
          url          : "/producciones",
          templateUrl  : "components/vinedo/produccion/vina.prod.view.html",
          load         : true,
          title        : 'Producciones',
          controller   : 'vinedoProdCtrl',
          controllerAs : 'vpr',
          // resolve:{
          //   producciones: ['VinedoFac', '$stateParams',
          //   function (VinedoFac, $stateParams) {
          //     return VinedoFac.getProducciones({vinedo_id:$stateParams.id},function(){});
          //   }]
          // },
        })

        .state('vinedo.fertilizaciones', {
          url         : "/fertilizaciones",
          templateUrl : "components/vinedo/fertilizacion/vina.fert.view.html",
          load        : true,
          title       : 'Fertilizaciones',
          // resolve:{
          //   producciones: ['VinedoFac', '$stateParams',
          //   function (VinedoFac, $stateParams) {
          //     return VinedoFac.getProducciones({vinedo_id:$stateParams.id},function(){});
          //   }]
          // },
          controller: 'vinedoFertCtrl'
        })


        .state('vinedo.estadisticas', {
          url         : "/estadisticas",
          templateUrl : "components/vinedo/estadisticas/vina.esta.view.html",
          load        : true,
          title       : 'Estadisticas',
          // resolve:{
          //   producciones: ['VinedoFac', '$stateParams',
          //   function (VinedoFac, $stateParams) {
          //     return VinedoFac.getProducciones({vinedo_id:$stateParams.id},function(){});
          //   }]
          // },
          controller: 'vinedoFertCtrl'
        })

        */





        //----------------------------------------------------------
        //------ Equipo --------------------------------------------
        //----------------------------------------------------------

        /*
        .state('equipo', {
          redirectTo   : "equipo.scholander",
          title        : 'Equipo',
          url          : "/equipo/{id:int}",
          templateUrl  : "components/equipo/equipo.view.html",
          controller   : "equipoCtrl",
          configVinedo : 'equipoTimeline',
          controllerAs : 'equ',
          resolve:{
            equipo: ['EquipoFac', '$stateParams', 'global', 'Config', 'newCacheManager',
            function (EquipoFac, $stateParams, global, Config, NCM){
              var prom = EquipoFac.getData($stateParams.id, null).$promise;
              prom.then(function(res){
                global.title     = res.data.nombre;
                global.titleData = null;
                Config.vinedo    = res.data.configuracion;

                    angular.forEach(Config.vinedo, function(item, index){
                      if (item == '1' || item === 1) {
                        Config.vinedo[index] = true;
                      }
                      if (item == '0' || item === 0) {
                        Config.vinedo[index] = false;
                      }
                    });
              });
              return prom;
            }],
          }
        })




        .state('equipo.timeline', {
          url: "/timeline",
          views:{
            "":{
              controller   : 'timelineEquipoCtrl',
              controllerAs : 'etl',
              templateUrl  : "components/equipo/timeline/equipo.timeline.view.html",
              resolve      : {
                volumenes: ["$http", "$stateParams", "urls",
                function($http, $stateParams, urls){
                  return $http.get(urls.BASE+"/vinedo/volumenes?vinedo_id="+$stateParams.id);
                }]
              }
            },
            'absoluteView@':{
              templateUrl  : "shared/timeTable/popover/programacion.tmpl.html",
                controller : 'popoverProgramacionCtrl',
              controllerAs : 'pp',
            }
          }
        })
        */

        /*




        .state('equipo.scholander', {
          url          : "/scholander",
          configVinedo : 'conScholander',
          templateUrl  : "components/equipo/scholander/equipo.scholander.view.html",
          controller   : 'equipoScholanderCtrl',
          controllerAs : 'esch',
          resolve      : {
            sectores: ['EquipoFac', '$stateParams', 'newCacheManager', function(EquipoFac, $stateParams, NCM){
              return EquipoFac.getSectoresScholander({equipo_id: $stateParams.id}, function(){});
            }],
          }
        })



        .state('equipo.programacion', {
          url          : "/programacion",
          configVinedo : 'riegoProgramado',
          templateUrl  : "components/equipo/programacion/equipo.programacion.view.html",
          controller   : 'equipoProgramacionCtrl',
          controllerAs : 'eprg',
          resolve      : {
            riegos: ['EquipoFac', '$stateParams', 'newCacheManager', function(EquipoFac, $stateParams, NCM){
              return EquipoFac.getRiegos($stateParams.id, null, function(){});
            }],
          }
        })
        .state('equipo.real', {
          url          : "/real",
          configVinedo : 'riegoProgramado',
          templateUrl  : "components/equipo/real/equipo.real.view.html",
          controller   : 'equipoRealCtrl',
          controllerAs : 'ere',
          resolve      : {
            riegos: ['EquipoFac', '$stateParams', 'newCacheManager', function(EquipoFac, $stateParams, NCM){
              return EquipoFac.getRiegos($stateParams.id, null, function(){});
            }],
          }
        })



          */





        //----------------------------------------------------------
        //------ Sector de Riego (cuartel) -------------------------
        //----------------------------------------------------------

        .state('cuartel', {
          redirectTo   : "cuartel.irriview",
          title        : 'Cuartel',
          url          : "/cuartel/{id:int}",
          controller   : 'cuartelCtrl',
          controllerAs : 'cua',
          templateUrl  : "components/cuartel/cuartel.view.html",
          resolve:{
            isDialog: function(){
              return false
            }
          },
        })




        .state('cuartel.irriview', {
          url                            : "/irriview",
          templateUrl                    : "components/cuartel/irriview/cuartel.irriview.view.html",
          controller                     : 'cuartelIrriViewCtrl',
          controllerAs                   : 'iv',
          resolve:{
            cuartel_id: ["$stateParams", function($stateParams){
              return $stateParams.id
            }]
          }
        })



        .state('cuartel.estadisticas', {
          url                            : "/estadisticas",
          templateUrl                    : "components/cuartel/detalle/cuartel.detalle.view.html",
          controller                     : 'cuartelDetalleCtrl',
          controllerAs                   : 'ces',
          resolve:{
            cuartel_id: ["$stateParams", function($stateParams){
              return $stateParams.id
            }],
            isDialog: function(){
              return false;
            }
          }
        })

      /*
        .state('cuartel.comparacion', {
          url                            : "/comparacion?mes&inicio&termino&estado&temporada",
          reloadOnSearch : false,
          templateUrl                    : "components/cuartel/comparacion/cuartel.comparacion.view.html",
          controller                     : 'cuartelComparacionCtrl',
          controllerAs                   : 'cc',
        })

        .state('cuartel.estados', {
          url          : "/estados",
          controller   : 'cuartelEstadosCtrl',
          controllerAs : 'cest',
          templateUrl  : "components/cuartel/estados/cuartel.estados.view.html",
          resolve      : {
            cuartelEstados: ['CuartelRes', '$stateParams', 'global', 'Config',
            function (CuartelRes, $stateParams, global, Config) {
              var prom = CuartelRes.getEstados({sector_riego_id: $stateParams.id, fecha: null},
                  function(data){}).$promise;
              return prom;
            }],
          }
        });
        */
    }])








    //para que, en las rutas padres, funcione redirectTo
    .run(['$rootScope','$location','$state', 'Config', 'global', 'CONSTANTES',function($rootScope, $location, $state, Config, global, CONSTANTES) {
      $rootScope.$on( '$stateChangeSuccess', function(e, toState  , toParams, fromState, fromParams) {
        global.state = toState.name.split(".").join("-");

            //si tiene el atributo de redirectTo, redirige
            if(angular.isDefined(toState.redirectTo) && toState.redirectTo !== "") {
              e.preventDefault(); // stop current execution
              var isMobile = global.responsiveIs("xs, sm");
              if(toState.redirectTo == CONSTANTES.INITIAL_STATE && isMobile){
                console.log("routes.js redirect mobile");
                $state.go(CONSTANTES.INITIAL_MOBILE_STATE, toParams);
              }else{
                $state.go(toState.redirectTo, toParams);
                console.log("routes.js redirect");
              }
              return;
            }

            //verifica si Config.vinedo (las configuraciones del vinedo actual)
            //corresponden a la vista cargada
            if (angular.isDefined(toState.configVinedo) &&
                angular.isDefined(Config.vinedo) &&
                !Config.vinedo[toState.configVinedo]) {
                  var parent = toState.name.split('.')[0];
                  e.preventDefault(); // stop current execution
                  $state.go(parent, toParams);
                  return;
            }
            //registra una pagina vista en mixpanel
            mixpanel.track('page viewed', {
              'page name'  : document.title,
              'url'        : window.location.pathname,
              'state'      : toState.name,
              'params'     : toParams,
              'fromState'  : fromState.name,
              'fromParams' : fromParams,
              'vina'       : angular.isDefined(global.selectedVina) && global.selectedVina !== null ?  global.selectedVina.nombre: "",
            });

        if(Raven){
            Raven.setTagsContext({
              state: toState.name,
            });

            if (angular.isDefined(global.selectedVina) && global.selectedVina !== null) {
              Raven.setTagsContext({
                vina: global.selectedVina.nombre
              });
            }
        }

      });
    }]);


})();
